// @flow
import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { GoogleDriveSetting } from 'types/google_integrations'

export async function getGoogleDriveSettings(): Promise<
  Array<GoogleDriveSetting>
> {
  return await makeGetRequest(ApiBase + '/google/drive/settings')
}

export async function getGoogleDriveSetting(
  id: string
): Promise<GoogleDriveSetting> {
  return await makeGetRequest(ApiBase + `/google/drive/settings/${id}`)
}
